import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap/lib';

class Editor extends Component {
    render() {
        return (
            <main>
                <Grid>
                    <Row>
                        <Col md={12}>
                            <h4 className="sub-heading">Editor</h4>
                            <h1 className="heading purple"><span className="purple">add</span> new <br /> projects to the app</h1>
                        </Col>
                    </Row>
                </Grid>
            </main>
        );
    }
}

export default connect()(Editor);


// WEBPACK FOOTER //
// ./src/components/Editor.js